import { NewNotificationSubscription } from "~/gql/graphql";

export const ElectronAPI = {
  sendAuthToken: (token: string) => {
    if (isElectron()) {
      window.bridge.sendAuthToken(token);
    }
  },
  sendNotification: (notification: NewNotificationSubscription["newNotification"]) => {
    if (isElectron()) {
      window.bridge.sendNotification(notification);
    }
  },
};

export const isElectron = () => window && window.bridge;
